import DOMPurify from "dompurify";

/** Minimal renderer for the AI summary (bold + bullet lists, Italian text). */
export function SummaryText({ text }) {
  if (!text) return null;
  const lines = text.split("\n");
  const blocks = [];
  let listItems = [];

  const flushList = (key) => {
    if (listItems.length) {
      blocks.push(
        <ul key={`ul-${key}`}>
          {listItems.map((li, i) => (
            <li key={i} dangerouslySetInnerHTML={{ __html: inline(li) }} />
          ))}
        </ul>
      );
      listItems = [];
    }
  };

  lines.forEach((raw, idx) => {
    const line = raw.trim();
    if (!line) {
      flushList(idx);
      return;
    }
    if (line.startsWith("- ") || line.startsWith("* ")) {
      listItems.push(line.slice(2));
    } else {
      flushList(idx);
      blocks.push(<p key={`p-${idx}`} dangerouslySetInnerHTML={{ __html: inline(line) }} />);
    }
  });
  flushList("end");

  return <div className="avz-summary text-sm text-zinc-700 leading-relaxed">{blocks}</div>;
}

function inline(s) {
  const html = s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
  return DOMPurify.sanitize(html, { ALLOWED_TAGS: ["strong"], ALLOWED_ATTR: [] });
}
